module.exports = {
  mmzs: 'Note: since the handheld pad password of the traceability system does not support all special characters, the special characters can only be # or # when resetting the account password of the traceability system@',
  mqzwdbcl: 'There is currently no to-do need to be processed！',
  cxyzzjjkfz: 'The program is in urgent development, please be calm！',
  yhtymh: 'Yihai Unified Portal',
  thtymhqxqbxt: 'All systems under Yihai Unified Portal',
  ghbj: 'Change background',
  hymr: 'Restore default',
  ckgd: 'see more',
  qd: 'confirm',
  qr: 'confirm',
  qx: 'cancel',
  tc: 'quit',
  czcg: 'Successful operation',
  wxts: 'Tips',
  // 登录页
  loginPage: {
    qhqyzm: 'Please get the verification code',
    tysfglpt: 'Unified portal system',
    zhdl: 'Account',
    yhmygbh: 'Username/Employee ID',
    sjhm: 'phone number',
    xgmm: 'change Password',
    mm: 'Password',
    qxgcsmm: 'Please modify the initial password',
    mmydqqxgmm: 'The password has expired, please change the password',
    xmmbnyjmmxt: 'The new password cannot be the same as the old password',
    xmm: 'new password',
    ymm: 'old password',
    qrxmm: 'Confirm the new password',
    wjmm: 'Forgot password',
    xyhddl: 'Swipe right to log in',
    yzcg: 'Verified successfully',
    smdl: 'Scan code',
    qywxsm: 'Enterprise WeChat Scan Code',
    ddsm: 'Scan code',
    fssm: 'Lark code',
    ewmysx: 'QR code has expired',
    sxewm: 'Refresh the QR code',
    dxyzm: 'SMS verification code',
    hqyzm: 'get verification code',
    xyb: 'Next step',
    dlsjyz: 'Login phone verification',
    wbll: 'external links',
    bq: 'copyright',
    mmbyz: 'Inconsistent passwords',
    hcxhq: 'Re-acquire after',
    qxsrzqdsjhm: 'Please enter the correct phone number first',
    qsrdxyzm: 'Please enter the SMS verification code',
    qsryhm: 'Please enter user name',
    qxzsjhm: 'Please select a mobile phone number',
    fscg: 'Sent successfully',
    yhmbnwk: 'Username can not be empty',
    yhmwgzf: 'User name 3-12 characters',
    yhmbnczkg: 'Username/employee number cannot contain spaces',
    mmbnwk: 'password can not be blank',
    ymmbnwk: 'The original password cannot be empty',
    mmwsfzhlw: 'The password is the last 6 digits of the ID card',
    mmzswzmsztszf: 'The password must be a combination of at least 8 letters, numbers, and special characters',
    mmzswzmsztszfnew: 'The password must be a combination of at least 8 letters, numbers, and special characters，Special characters can only use # or@'
  },
  // 首页
  homePage: {
    ty: 'Thai',
    hy: 'Korean',
    gh: 'job number',
    zh: 'account number',
    gw: 'post',
    sj: 'phone',
    yx: 'email',
    yy: 'language',
    pf: 'skin',
    bj: 'background',
    yh: 'agent',
    xtyyxz: 'System language selection',
    zwjt: 'Simplified Chinese',
    zwft: 'Traditional Chinese',
    yw: 'English',
    qb: 'total',
    wdyy: 'My apps',
    dlbjxgqh: 'Login background effect switch',
    zjbj: 'Middle background',
    ybbj: 'Right background',
    qhdlr: 'Switch agent',
    xtpfqh: 'System skin switch'
  }
}
